import axios from 'axios';
import { apiPost } from './apiRequest';

export const loginService = async ({ username, password, remember }) => {
  const res = await apiPost('/login', {
    user: {
      email: username,
      password: password,
      checkLogin: remember,
    },
  });
  return res?.data || res;
};

export const logoutService = async () => {
  const res = await apiPost('/logout');
  return res?.data;
};



const axiosInstance = axios.create({
  baseURL: 'https://api.dev.umb-360.com',
  timeout: 1000,
});

export const resetPasswordService = async (userName) => {
  const userInfo = {
    username: userName,
  };

  try {
    const response = await axiosInstance.post('/api/forget-password', userInfo);

    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};





export const setNewPasswordService = async ({ username, code, password }) => {
  try {
    const response = await axiosInstance.post('/api/reset-password', {
      username,
      code,
      password,
    });

    return response?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const contactUsService = async ({ name, email, phone, message }) => {
  const contactData = {
    name,
    email,
    phone,
    message,
  };

  try {
    const response = await axiosInstance.post('/api/contact-us', contactData);

    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};
